import { render, staticRenderFns } from "./AdminTrendChart.vue?vue&type=template&id=49c55756"
import script from "./AdminTrendChart.vue?vue&type=script&lang=js"
export * from "./AdminTrendChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports